import { Create } from "@/components/admin/create";
import { SimpleForm } from "@/components/admin/simple-form";
import { AccountInputs } from "./AccountInputs";

export const AccountCreate = () => (
  <Create mutationMode="pessimistic" redirect="list">
    <SimpleForm
      className="max-w-3xl"
      defaultValues={{ type: "cash", initial_balance: 0, currency: "RUB" }}
    >
      <AccountInputs />
    </SimpleForm>
  </Create>
);
